import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { Clock, ChefHat } from "lucide-react";
import { metaFor } from "@/lib/cuisines";

export const RecipeCard = ({ recipe, index = 0 }) => {
  const meta = metaFor(recipe.cuisine);
  return (
    <motion.div
      initial={{ opacity: 0, y: 24 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-40px" }}
      transition={{ duration: 0.5, delay: (index % 6) * 0.08, ease: "easeOut" }}
    >
      <Link
        to={`/recipe/${recipe.id}`}
        data-testid={`recipe-card-${recipe.id}`}
        className="group block border border-gray-200 bg-white hover:border-gray-900 transition-colors duration-300"
      >
        <div className="overflow-hidden aspect-[4/3]">
          <img
            src={recipe.image}
            alt={recipe.name}
            loading="lazy"
            className="w-full h-full object-cover transition-transform duration-500 ease-out group-hover:scale-105"
          />
        </div>
        <div className="p-6">
          <div className="flex items-center gap-2 mb-3">
            <span className={`inline-block h-2 w-2 rounded-full ${meta.dot}`} />
            <span className="text-[11px] font-semibold uppercase tracking-[0.2em] text-gray-500">
              {meta.name}
            </span>
          </div>
          <h3 className="font-heading text-2xl font-medium leading-tight text-gray-900 mb-2">
            {recipe.name}
          </h3>
          <p className="text-sm text-gray-500 font-light leading-relaxed line-clamp-2">
            {recipe.description}
          </p>
          <div className="mt-5 flex items-center gap-4 text-xs text-gray-600">
            <span className="inline-flex items-center gap-1.5">
              <Clock className="h-3.5 w-3.5" /> {recipe.cook_time}
            </span>
            <span className="inline-flex items-center gap-1.5">
              <ChefHat className="h-3.5 w-3.5" /> {recipe.difficulty}
            </span>
          </div>
        </div>
      </Link>
    </motion.div>
  );
};
